import "prebid.js/modules/seedtagBidAdapter";

import type {IPrebidJsBidder} from "header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/iPrebidJsBidder";
import type {HeaderBiddingConfig} from "header-bidding-client-base/modules/config/domain/headerBiddingConfig";
import {Bidders} from "header-bidding-base/modules/header-bidding/domain/bidders";
import {PrebidJsBaseBidder} from "./prebidJsBaseBidder";
import {SeedtagAdUnit} from "header-bidding-base/modules/config/domain/bidders/seedtagConfig";

export class SeedtagBidder extends PrebidJsBaseBidder implements IPrebidJsBidder<SeedtagAdUnit> {
    public constructor(config: HeaderBiddingConfig) {
        super(config, Bidders.SEEDTAG);
    }
}
